
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/create-ai/error",
      function () {
        return require("private-next-pages/create-ai/error.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/create-ai/error"])
      });
    }
  